<template>
  <div class="md:flex md:gap-5 h-full overflow-hidden relative">
    <div
        class="transition-all duration-300"
        :class="[
        width < 1280
          ? ' absolute h-full top-0 md:w-[260px] w-[200px] z-[999]'
          : 'flex-none min-w-[260px]',
        width < 1280 && mobileWalletSidebar
          ? 'ltr:left-0 rtl:right-0'
          : 'ltr:-left-full rtl:-right-full ',
      ]"
    >
      <Card class-name="h-full" bodyClass="h-full flex flex-col">
        <div class="flex flex-col h-full">
          <div class="flex-1 h-full overflow-y-auto">
            <div class="h-full pb-10 px-3 overflow-y-auto custom-scrollbar">
              <ul class="list mt-6">
                <li @click="selectMyWallet" :class="
                [
                    'cursor-pointer px-4 py-2 rounded transition',
                    activeUsername === 'my' ? 'bg-slate-700 text-slate-200' : 'text-slate-200'
                  ]">
                  My Wallet
                </li>
                <li @click="selectLinkedWallet(user)" v-for="user in sortedLinkedUsernames" :key="user" :class="[
          'cursor-pointer px-4 py-2 rounded transition',
          activeUsername === user ? 'bg-slate-700 text-slate-200' : 'text-slate-200'
        ]">
                  {{ user }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Card>
    </div>
    <Transition name="overlay-fade">
      <div
          v-if="width < 1280 && mobileWalletSidebar"
          class="overlay bg-slate-900 dark:bg-slate-900 dark:bg-opacity-60 bg-opacity-60 backdrop-filter backdrop-blur-sm absolute w-full flex-1 inset-0 z-[99] rounded-md"
          @click="walletStore.closeMobileWalletSidebar()"
      ></div>
    </Transition>
    <div
        class="flex-1 h-full"
        :class="width < 768 ? 'h-full' : ''"
    >
      <Card
          bodyClass="p-0 h-full relative"
          class-name="h-full"
      >
        <div class="all-allEmails h-full flex flex-col">
          <Wallets :wallets="selectedWallets"/>
          <Transition name="singleEmail">
            <Transactions v-if="singleWalletModal"/>
          </Transition>
        </div>
      </Card>
    </div>

  </div>
</template>
<script setup>
import Card from "@/components/Card/index.vue";
import {computed, ref, onMounted, watch} from "vue";
import {useWalletStore} from "@/stores/wallet.js";
import Wallets from "@/views/wallet/WalletTable2.vue";
import Transactions from "@/views/wallet/Transactions2.vue";

let walletStore = useWalletStore();
const width = ref(0);
const handleResize = () => {
  width.value = window.innerWidth;
};

// store  computed
const singleWalletModal = computed(() => walletStore.singleWalletModal);
const mobileWalletSidebar = computed(() => walletStore.mobileWalletSidebar);

// State
const selectedWallets = computed(() => {
  if (activeUsername.value === 'my') {
    return [...walletStore.wallets].sort((a, b) => b.lastUpdate - a.lastUpdate);
  }
  return [...walletStore.linkedWallets]
      .filter(w => w.username === activeUsername.value)
      .sort((a, b) => b.lastUpdate - a.lastUpdate);
});

const activeUsername = ref('my') // ← default: 'my' wallet is selected

// Computed: usernames in order
const sortedLinkedUsernames = computed(() => [
  ...walletStore.getUniqueUserNames
])


// Methods
function selectMyWallet() {
  activeUsername.value = 'my';
  walletStore.selectedUserName = 'My Wallet';
}

function selectLinkedWallet(username) {
  activeUsername.value = username;
  walletStore.selectedUserName = username;
}


watch(
    activeUsername,
    () => {
      walletStore.closeDetailsEmail()
      walletStore.closeMobileWalletSidebar()
    },
    {deep: true}
);

onMounted(async () => {
  window.addEventListener("resize", handleResize);
  handleResize();
  await walletStore.action_getWallets();
  selectMyWallet();
});
</script>
<style lang="scss">
.singleEmail-enter-active {
  animation: fade-in-left 0.44s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.singleEmail-leave-active {
  animation: fade-in-left 0.34s cubic-bezier(0.39, 0.575, 0.565, 1) both reverse;
}

@keyframes fade-in-left {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.email_height {
  height: calc(var(--vh, 1vh) * 100 - 12.1rem);
}

@media (max-width: 768px) {
  .email_height {
    height: calc(var(--vh, 1vh) * 100 - 10.5rem);
  }
}
</style>
